import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';

const CARD_THEMES = {
  create: {
    outer: 'linear-gradient(180deg, #3978FF 0%, #9E58FF 100%)',
    inner: 'radial-gradient(circle at center, #540198 63%, #3C016C 100%)',
  },
  join: {
    outer: 'linear-gradient(180deg, #FF00F2 0%, #9E58FF 100%)',
    inner: 'radial-gradient(circle at center, #840198 63%, #5E016C 100%)',
  },
};

const HousieActionCard = ({
  title,
  description,
  descriptionLine2,
  image,
  onClick,
  variant = 'join',
  style = {},
}) => {
  const theme = CARD_THEMES[variant] || CARD_THEMES.join;

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.03)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 368,
        minHeight: 210,
        border: 'none',
        borderRadius: 22,
        padding: 0,
        overflow: 'hidden',
        cursor: 'pointer',
        background: theme.outer,
        boxShadow: '0px 9px 4px rgba(0,0,0,0.7)',
        transform: 'scale(1)',
        transition: 'transform 0.25s ease',
        ...style,
      }}
    >
      <div
        style={{
          width: '100%',
          height: 130,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          background: theme.inner,
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: 96,
            height: 96,
            objectFit: 'contain',
            pointerEvents: 'none',
          }}
        />
      </div>
      <div
        style={{
          flex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 16px 14px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontFamily: FONTS.INTER_SEMIBOLD,
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: 0.8,
            color: '#FFFFFF',
          }}
        >
          {title}
        </div>
        <div
          style={{
            marginTop: 4,
            fontFamily: FONTS.INTER_REGULAR,
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '20px',
            letterSpacing: 0.8,
            color: '#FFFFFF',
            opacity: 0.8,
          }}
        >
          <div>{description}</div>
          {descriptionLine2 ? <div>{descriptionLine2}</div> : null}
        </div>
      </div>
    </button>
  );
};

HousieActionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionLine2: PropTypes.string,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['create', 'join']),
  style: PropTypes.object,
};

export default HousieActionCard;
